import { render, staticRenderFns } from "./SubSource.vue?vue&type=template&id=6f86207c"
import script from "./SubSource.vue?vue&type=script&lang=js"
export * from "./SubSource.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports